<template>
    <div id="pageTable" class="mainView">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-btn color="primary" dark @click="simulation">시뮬레이션</v-btn>
                </v-flex>

                <v-flex xs12 sm6 md12>
                    <v-text-field
                            mask="####"
                            label="1인당 서비스 이용료"
                            v-model="passengerSoloServiceFee"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                    <v-text-field
                            label="승객1 출발지"
                            placeholder="콤마로 구분하여 입력 ex) 37.50036,127.0248313"
                            v-model="start1"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                    <v-text-field
                            label="승객1 도착지"
                            placeholder="콤마로 구분하여 입력 ex) 37.50036,127.0248313"
                            v-model="end1"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                    <v-text-field
                            label="승객2 출발지"
                            placeholder="콤마로 구분하여 입력 ex) 37.50036,127.0248313"
                            v-model="start2"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                    <v-text-field
                            label="승객2 도착지"
                            placeholder="콤마로 구분하여 입력 ex) 37.50036,127.0248313"
                            v-model="end2"
                    ></v-text-field>
                </v-flex>

                <template v-for="(simulationResult, index) in simulationResults">
<!--                    <v-flex lg12>-->
<!--                        <h3 v-if="index == 0"><b><<< 기존 매칭 계산 (직선거리로 중복구간 계산, 요금비율로 요금계산) >>></b></h3>-->
<!--                        <h3 v-if="index == 1"><b><<< 변경 매칭 계산 (실제거리로 중복구간 계산, 거리비율로 요금계산) >>></b></h3>-->
<!--                    </v-flex>-->

                    <v-flex lg12>
                        <b><<< 매칭 정보 >>></b><br/>
                    </v-flex>

                    <v-flex lg12 v-if="simulationResult">
                        매칭 결과 : {{simulationResult.matched ? '성공' : '실패'}}<br/>
                        <template v-if="!simulationResult.matched">
                            <br/>[실패 사유]<br/>
                            <template v-if="simulationResult.startDiffLimit">
                                <span>출발지간의 거리가 너무 멉니다.</span><br/>
                            </template>

                            <template v-if="simulationResult.dupLimit">
                                <span>중복구간이 적습니다.</span><br/>
                            </template>

                            <template v-if="simulationResult.timeLimit">
                                <span>시간이, 혼자 갔을 때 비해서 너무 오래 걸립니다.</span><br/>
                            </template>

                            <template v-if="simulationResult.feeLimit">
                                <span>할인률이 너무 낮습니다.</span> <br/>
                            </template>
                        </template>

                        <br/>
                        총 거리 : {{simulationResult.totalDistance}} M<br/>
                        출발지간의 거리 : {{simulationResult.startDistanceDiff}} M<br/>
                        동승거리 : {{simulationResult.dupDistance}} M<br/>
                        도착지간의 거리 : {{simulationResult.endDistanceDiff}} M<br/><br/>

                        중복률 : {{simulationResult.dupRatio}}<br/>
                        승객1 우회율 : {{simulationResult.detourRatio1}}<br/>
                        승객2 우회율 : {{simulationResult.detourRatio2}}<br/>

                        <template v-if="simulationResult.totalFee">
                            <br/>
                            <b>기사가 받는 요금 : {{simulationResult.totalFee}} 원</b><br/>
                            <b>승객1이 내는 요금 : {{simulationResult.taxiFee1}} 원 (서비스 이용료 미포함)</b><br/>
                            <b>승객2가 내는 요금 : {{simulationResult.taxiFee2}} 원 (서비스 이용료 미포함)</b><br/>
                            <br/>

                            <b>총 걸린 시간 : 약 {{simulationResult.totalTime / 60}} 분</b><br/>
                            <!--<b>승객1의 우회 시간 : {{ (simulationResult.totalTime - simulationResult.soloPredictTime1) / 60 }} 분</b><br/>-->
                            <!--<b>승객2의 우회 시간 : {{ (simulationResult.totalTime - simulationResult.soloPredictTime2) / 60 }} 분</b><br/>-->
                            <b>승하차 순서 : 1 -> 2 -> {{simulationResult.path[2]}} -> {{simulationResult.path[3]}}</b><br/>

                            <p>------------------------------------------------------------------------------------</p>

                            <b><<< 혼자 갔을 때 정보 >>></b><br/>
                            승객1이 혼자갔을 때 내는 요금 : {{simulationResult.soloPredictFee1}} 원<br/>
                            승객1이 최소 할인받아야 하는 요금 : {{simulationResult.minimumDiscountTaxiFee1}} 원<br/>
                            승객1이 혼자갔을 때 총 거리 : 약 {{simulationResult.soloPredictDistance1}} M <br/>
                            승객1이 걸리는 시간 : 약 {{simulationResult.soloPredictTime1 / 60}} 분
                            <br/><br/>
                            승객2이 혼자갔을 때 내는 요금 : {{simulationResult.soloPredictFee2}} 원<br/>
                            승객2이 최소 할인받아야 하는 요금 : {{simulationResult.minimumDiscountTaxiFee2}} 원<br/>
                            승객2이 혼자갔을 때 총 거리 : 약 {{simulationResult.soloPredictDistance2}} M <br/>
                            승객2이 걸리는 시간 : 약 {{simulationResult.soloPredictTime2 / 60}} 분<br/><br/>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        // start1: null,
        // end1: null,
        // start2: null,
        // end2: null,
        start1: '37.498793,127.027417',
        end1: '37.276876,126.971461',
        start2: '37.501602,127.024021',
        end2: '37.268306,126.999544',
        passengerSoloServiceFee: 0,
        simulationResults: null
      };
    },
    mounted () {
      for (let i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].chkAutoReload != null) {
          this.$parent.$children[i].chkAutoReload();
        }
      }
    },
    methods: {
      banbanCreated () {},
      simulation () {
        const parameters = {
          method: 'simulation'
        };

        try {
          let start1Arr = this.start1.split(',');
          let end1Arr = this.end1.split(',');
          let start2Arr = this.start2.split(',');
          let end2Arr = this.end2.split(',');

          parameters.startLat1 = start1Arr[0].trim();
          parameters.startLon1 = start1Arr[1].trim();
          parameters.endLat1 = end1Arr[0].trim();
          parameters.endLon1 = end1Arr[1].trim();
          parameters.startLat2 = start2Arr[0].trim();
          parameters.startLon2 = start2Arr[1].trim()
          parameters.endLat2 = end2Arr[0].trim();
          parameters.endLon2 = end2Arr[1].trim();

        } catch(e) {
          console.log(e);
          alert('출발지, 목적지를 정확하게 입력해 주세요.');
          return;
        }

        if(!this.passengerSoloServiceFee || this.passengerSoloServiceFee < 1 || this.passengerSoloServiceFee.length < 3) {
            alert('1인당 서비스 이용료를 정확하게 입력해 주세요.');
            return;
        }

          parameters.passengerSoloServiceFee = this.passengerSoloServiceFee;

        this.$store.dispatch('banbanAPI', parameters)
          .then(({ data }) => {
            top.getApp.progress.dialog = false;

            this.simulationResults = data;
          })
          .catch((error) => {
            top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/simulation/Simulation.vue